/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/053-folder-upload': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9 4L7 2H0v13h16V4H9zM8 7.5l3.5 3.5H9v4H7v-4H4.5L8 7.5z"/>'
  }
})
